import { Component, ElementRef, Input, NgZone, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../vdms_core/services/vehicle/vehicle.data.services';
import { DateExpirePipe } from '../../vdms_shared/pipes/date-expire.pipe';
import { FuelcardService } from '../../vdms_core/services/api/fuelcard.service';

@Component({
  selector: 'app-fuel-card-details-list',
  templateUrl: './fuel-card-details-list.component.html',
  styleUrls: ['./fuel-card-details-list.component.css']
})
export class FuelCardDetailsListComponent implements OnInit {

  @Input() inputCardDetailsList: any;
  columnfilter = {
    card_number: {
      singleSelection: false,
      idField: "card_number",
      textField: "text",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search New Card No.",
    },
    status: {
      singleSelection: false,
      idField: "status",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Card Status.",
    },
    card_provider: {
      singleSelection: false,
      idField: "card_provider",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Card Provider.",
    },
    card_expiry_date: {
      singleSelection: false,
      idField: "card_expiry_date",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Card Expiry.",
    }
  }

  cardnoFilterModel: any = new Array();
  cardProviderFilterModel: any = new Array();
  cardExpiryFilterModel: any = new Array();

  filteredFuelCard: any[] = [];
  pageSize: number = 10;
  activePage: number = 1;



  cardnoFilterData: any = [];
  cardProviderFilterData: any = [];
  cardExpiryFilterData: any = [];

  blockedCardData: any = [];
  @ViewChild('closeModal') closeModal: ElementRef;

  constructor(
    private zone: NgZone,
    public dataService: DataService,
    private router: Router,
    private dateExpirePipe: DateExpirePipe,
    private fuelService: FuelcardService
  ) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    if (!this.inputCardDetailsList) {
      setTimeout(() => {
        if (Array.isArray(this.inputCardDetailsList) && this.inputCardDetailsList.length > 0) {
          this.initializeFilterData(true);
        }
      }, 0);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('ASSIGNED_CAR', this.inputCardDetailsList);
    if (changes.inputCardDetailsList && Array.isArray(changes.inputCardDetailsList.currentValue)) {
      this.filteredFuelCard = [...this.inputCardDetailsList];
      console.log('filteredVehicles', this.filteredFuelCard)
      this.initializeFilterData(true);
      //this.updatePaginatedData();
    }
  }

  editRow(record: any) {
    this.dataService.setRecord(record);
    this.router.navigate(['/pages/add-fuel-card-details']);

  }

  viewRow(record: any) {
    // Using the service to pass data
    record['isViewMode'] = true
    this.dataService.setRecord(record);
    this.router.navigate(['/pages/add-fuel-card-details']);

  }


  /*************************************************************************
 * FILTER FUNCTION DECLARATION
 ************************************************************************/

  private pushIfValid(arr: any[], value: any): void {
    if (value != null && !arr.includes(value)) {
      arr.push(value);
    }
    else {
      console.log('Invalid or duplicate value:', value);
    }
  }

  initializeFilterData(isData: boolean) {
    this.cardnoFilterData = [];
    this.cardProviderFilterData = [];
    this.cardExpiryFilterData = [];

    // Populate the filter data arrays
    for (const item of this.inputCardDetailsList) {
      const cardStatus = this.dateExpirePipe.transform(item.card_expiry_date);
      this.pushIfValid(this.cardnoFilterData, { card_number: item.card_number, text: item.card_number });
      this.pushIfValid(this.cardProviderFilterData, item.card_provider);
      this.pushIfValid(this.cardExpiryFilterData, cardStatus.status);
    }



    // Update dropdown data with proper change detection
    const updateDropdownData = () => {
      this.cardnoFilterData = [...this.cardnoFilterData];
      this.cardProviderFilterData = [...this.cardProviderFilterData];
      this.cardExpiryFilterData = [...this.cardExpiryFilterData];
    };

    if (isData) {
      // Update immediately when `isData` is true
      updateDropdownData();
    } else {
      // Use Angular's `zone` to avoid ExpressionChangedAfterItHasBeenCheckedError
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          this.zone.run(() => {
            updateDropdownData();
          });
        }, 15000);
      });
    }
  }

  onFilterChange() {
    this.filteredFuelCard = this.inputCardDetailsList.filter(vehicle => {
      const cardStatus = this.dateExpirePipe.transform(vehicle.card_expiry_date).status;

      // Helper function to check if a value matches the filter
      const matchesFilter = (filter: any[], value: any) => {
        if (!filter || filter.length === 0) return true;

        const filterStrArr = filter.map(f => {
          if (typeof f === 'string') return f;
          if (typeof f === 'object' && f !== null) {
            return f.card_number || f.text || '';
          }
          return String(f);
        });

        return filterStrArr.includes(String(value));
      };

      this.cardnoFilterData = [...this.cardnoFilterData];
      this.cardProviderFilterData = [...this.cardProviderFilterData];
      this.cardExpiryFilterData = [...this.cardExpiryFilterData];
      // Checking if the vehicle matches all filters
      const matchCardNo = matchesFilter(this.cardnoFilterModel, vehicle.card_number);
      const matchCardProvider = matchesFilter(this.cardProviderFilterModel, vehicle.card_provider);
      const matchCardExpiry = matchesFilter(this.cardExpiryFilterModel, cardStatus);
      // Return true only if all criteria match
      return (
        matchCardNo &&
        matchCardProvider &&
        matchCardExpiry
      );

    });
  }


  blockRow(record: any) {
    let modalData = {
      id: record.id,
      card_number: record.card_number,
      card_provider: record.card_provider,
      assigned_car_id: '',
      rn_id: '',
      vehicle_reg_id: ''
    }
    this.fuelService.getAssignedCarByFuelCardId(record.id).then(async (res: any) => {
      if (res.length > 0) {
        modalData.assigned_car_id = res[0].assigned_car.id;
        modalData.rn_id = res[0].user_data.user_name;
        modalData.vehicle_reg_id = res[0].car_data.veh_reg_id;
        this.blockedCardData = modalData;
      }
    });
  }

  reset() {
    this.blockedCardData = [];
  }

  blockIt() {
    this.fuelService.updateAssignedCarDetail({
      fuel_card_id: '',
      id: this.blockedCardData.assigned_car_id,
    }).then((res: any) => {
      console.log(res, "update assigned car response");
      this.updateFuelCardStatus();
    });

  }

  updateFuelCardStatus() {
    this.fuelService.blockFuelCard(this.blockedCardData.id).then((res: any) => {
      this.inputCardDetailsList = this.inputCardDetailsList.filter((card: any) => card.id !== this.blockedCardData.id);
      this.filteredFuelCard = this.filteredFuelCard.filter((card: any) => card.id !== this.blockedCardData.id);
      this.initializeFilterData(false);
      this.closeModal.nativeElement.click();
    });
  }

}
